import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { CustomNavigate } from '@/components/functional/Link/CustomNavigate';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { CustomRoute } from '@/components/functional/Link/CustomRoute';
import { CustomRoutes } from '@/components/functional/Link/CustomRoutes';
import { useAuthentication } from '@/hooks/auth/useAuthentication';
import { useMatch } from '@/hooks/lib/react-router/useMatch';
import { RfpClientOneFileAllRoot } from '@/pages/rfp/client/RfpClientOneFileAllRoot';
import { RfpClientOneFileOne } from '@/pages/rfp/client/RfpClientOneFileOne/RfpClientOneFileOne';
import { RfpClientOneFileOneNoData } from '@/pages/rfp/client/RfpClientOneFileOneNoData/RfpClientOneFileOneNoData';
import { pagePath, getChildPath } from '@/utils/router/pagePath';
const rootPath = pagePath.project.client.fileRoot(':id');
const clientPath = pagePath.project.client;
export const RfpClientOneFileRoot = () => {
    var _a, _b;
    const isfileAll = !!((_a = useMatch(clientPath.fileAll(':id'))) === null || _a === void 0 ? void 0 : _a.pattern.end);
    const isfileAllConfirm = !!((_b = useMatch(clientPath.fileAllConfirm(':id'))) === null || _b === void 0 ? void 0 : _b.pattern.end);
    // 認証周りの判定取得
    const { message: authRedirectMessage, profile, redirectTo: authRedirectTo, } = useAuthentication({
        // Proffit権限を持つユーザーは表示可
        isCanUseProffit: true,
        // 仮登録ユーザーは表示不可
        isPreClient: false,
        // プレビュー表示を許可
        isPreview: true,
    });
    // リダイレクト: ユーザー認証
    if (authRedirectTo) {
        return _jsx(CustomRedirect, { message: authRedirectMessage, to: authRedirectTo });
    }
    return (_jsxs(CustomRoutes, { children: [_jsx(CustomRoute, { element: _jsx(RfpClientOneFileOneNoData, { profile: profile }), path: getChildPath(clientPath.fileNoMessage(':id'), rootPath) }), _jsx(CustomRoute, { element: _jsx(RfpClientOneFileOne, { profile: profile }), path: getChildPath(clientPath.fileOneMessage(':id', ':viewRequestId'), rootPath) }), !!(isfileAll || isfileAllConfirm) && (_jsx(CustomRoute, { element: _jsx(RfpClientOneFileAllRoot, { profile: profile }), path: '*' })), _jsx(CustomRoute, { element: _jsx(CustomNavigate, { to: pagePath.notfound() }), path: '*' })] }));
};
